import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { easing } from './lib/easing';
import Icon from './Icon';

export const Thead = styled.thead``;

const stickyStyles = css`
  border-collapse: separate;
  ${Thead} {
    position: sticky;
    top: 0px;
    background-color: var(--white);
    border-bottom: 1px solid var(--tint-black);
  }
`;

export const Table = styled.table`
  background: var(--white);
  border-collapse: collapse;
  color: var(--table-text);
  width: 100%;

  ${({ sticky }) => sticky && stickyStyles}
`;

export const Tbody = styled.tbody``;

export const Tfoot = styled.tfoot``;

export const Tr = styled.tr``;

export const Td = styled.td`
  border-bottom: 1px solid var(--table-border);
  padding: 8px 24px;
  vertical-align: middle;
  white-space: nowrap;

  @media print {
    white-space: normal;
  }
`;

const ThWrapper = styled.th`
  border-bottom: 1px solid var(--table-border);
  font-weight: var(--bold);
  padding: 8px 24px;
  vertical-align: middle;
  white-space: nowrap;
  transition: ${easing('background')};

  :hover {
    ${({ sortable }) => sortable && `background: var(--table-header-hover);`}
  }

  ${({ sortable }) =>
    sortable &&
    `
      cursor: pointer
  `};

  ${({ sortable, sorted }) =>
    sortable &&
    sorted &&
    `
      border-bottom: 2px solid var(--table-header-sorted);
    `}

  @media print {
    white-space: normal;
    width: auto;
  }
`;

const ThSortIcon = styled(Icon)`
  font-size: var(--xx-small);
  margin-left: 8px;
`;

const ThContent = styled.span`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

function BaseTh({ children, sorted, ...props }) {
  return (
    <ThWrapper sorted={sorted} {...props}>
      <ThContent>
        {children}
        {sorted === 'asc' && <ThSortIcon icon="arrow-up" />}
        {sorted === 'desc' && <ThSortIcon icon="arrow-down" />}
      </ThContent>
    </ThWrapper>
  );
}

BaseTh.propTypes = {
  children: PropTypes.node,
  sortable: PropTypes.bool,
  sorted: PropTypes.oneOf(['asc', 'desc']),
};

export const Th = styled(BaseTh)``;
